'use strict';

var CxToCyCanvas = require('./cx_to_cy_canvas.js').CxToCyCanvas;

module.exports = {CxToCyCanvas};
